import { useEffect, useState } from 'react';

export interface CompanyOption {
  id: string;
  name: string;
}

export const resolveActiveCompanyFilter = (
  selectedCompanyId: string,
  toolbarCompanyFilter?: string
) => {
  if (toolbarCompanyFilter && toolbarCompanyFilter !== 'all') {
    return toolbarCompanyFilter;
  }

  return selectedCompanyId;
};

/** Raw toolbar value for tab visibility (`all` = show every tab). */
export const resolveToolbarTabCompanyFilter = (
  toolbarCompanyFilter?: string | null
): string => {
  const raw = String(toolbarCompanyFilter ?? '').trim();
  if (!raw || raw === 'all' || raw === 'global') {
    return 'all';
  }
  return raw;
};

export const useCompanyOptions = (
  fetchCompanies: () => Promise<CompanyOption[]>
) => {
  const [companies, setCompanies] = useState<CompanyOption[]>([]);

  useEffect(() => {
    let isMounted = true;

    const loadCompanies = async () => {
      try {
        const companiesData = await fetchCompanies();
        if (isMounted) {
          setCompanies(companiesData || []);
        }
      } catch (error) {
        console.error('Error loading companies:', error);
      }
    };

    loadCompanies();

    return () => {
      isMounted = false;
    };
  }, [fetchCompanies]);

  return { companies };
};
